// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2ZvGW","inner":"Form_inner__u-9Jx","range":"Form_range__kjkZI","name":"Form_name__3XEbT","actions":"Form_actions__3ehoO"};